module.exports = __webpack_public_path__ + "static/media/BI.21c1ff1f.svg";